import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from './cx.js';
const ROUNDED = { sm: 'rounded-sm', lg: 'rounded-lg', full: 'rounded-full' };
const TONE = { surface: 'bg-fill-strong', accent: 'bg-accent-on/20' };
/**
 * A place held while its content loads, in the shape of what comes: a calm pulse in the fill.
 * Hidden from assistive technology - the region around it says it is loading (`aria-busy`).
 * Inline in text (a count in a tab) it is `inline`; on the accent (a tile) its tone is `accent`.
 * Display, corners and fill are props, not classes: two classes of one property would clash.
 */
export function Skeleton({ className, inline = false, rounded = 'sm', tone = 'surface', }) {
    return (_jsx("span", { "aria-hidden": true, className: cx(inline ? 'inline-block' : 'block', 'animate-pulse', ROUNDED[rounded], TONE[tone], className) }));
}
//# sourceMappingURL=skeleton.js.map